// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3q5i0","content":"styles_content__1DW_o"};